import React, {Component, PureComponent} from 'react';
import Icon from '../iconfont-icon';
import './style.scss';
import {withRouter} from "react-router-dom";
import ClipboardButton from 'react-clipboard.js';
import { Icon as MtdIcon,message } from '@ss/mtd-react'
import {addIconInLs, addIconsInLs, deleteIconInLs, getIconsInLs} from "@/utils/index";

class IconItem extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            copytipShow: false,
            copyError: false,
            showButtons: [],
            toolList: [],
            isContainedByCart: false
        }
    }


    async componentDidMount() {
        const { icon,scope,actor,isShowButton = true } = this.props;
        let { toolList } = this.state
        // 初始化按钮列表
        await this.updateShowButtons()
        // 初始化是否被收藏
        this.updateContainedState()
        window.addEventListener('cartsStorageChange', this.handleCartStorageChange);
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevState.isContainedByCart !== this.state.isContainedByCart) {
            await this.updateShowButtons()
        }
    }

    componentWillUnmount() {
        window.removeEventListener('cartsStorageChange', this.handleCartStorageChange);
    }

    handleCartStorageChange = (event) => {
        this.updateContainedState();
    }

    initToolList = async ()=>{
        const {
            icon, onDownload, onUpdate, onDelete, onActive,
        } = this.props;
        const { isContainedByCart } = this.state
        // 阻止冒泡
        const toolList = {
            download: (
                <MtdIcon type="download-o"  onClick={(e)=> {
                    e.stopPropagation();
                    onDownload && onDownload();
                }} className={'tool-item'}  />
            ),
            active: (
                <MtdIcon type="refresh-o"  onClick={(e)=> {
                    e.stopPropagation();
                    onActive && onActive();
                }} className={'tool-item'}  />
            ),
            cart: (
                <MtdIcon type={`${isContainedByCart ? 'cart-fill' : 'cart-o'}`} onClick={(e)=> {
                    e.stopPropagation();
                    this.selectIcon(icon.materialId);
                }} className={'tool-item'} />
            ),
            delete: (
                <MtdIcon type="delete-o" onClick={(e)=> {
                    e.stopPropagation();
                    onDelete && onDelete();
                }} className={'tool-item'}  />
            ),
            update: (
                <MtdIcon type="edit-o" onClick={(e)=> {
                    e.stopPropagation();
                    onUpdate && onUpdate();
                }} className={'tool-item'}  />
            ),
        };
        await this.setState({
            toolList
        })
        return toolList
    }

    async updateShowButtons(){
        // 更新按钮列表
        const { icon,scope,actor,isShowButton = true } = this.props;
        let { toolList } = this.state
        if(isShowButton){
            toolList = await this.initToolList();
            const showBtnList = this.generateToolBtns(icon,scope,actor)
            const shownBtnListInfo = [];
            if (showBtnList && showBtnList.length) {
                showBtnList.forEach((btn) => {
                    if (toolList[btn]) {
                        shownBtnListInfo.push(toolList[btn]);
                    }
                });
            }
            this.setState({
                showButtons: shownBtnListInfo,
            })
        }
    }

    updateContainedState() {
        const { icon } = this.props;
        const iconsInLocalStorage = getIconsInLs();
        this.setState({
            isContainedByCart: iconsInLocalStorage && !!iconsInLocalStorage.has(icon.materialId)
        })
    }

    copySuccess = () => {
        this.setState({
            copytipShow: true,
            copyError: false,
        });
        message.success({
            message: 'Copy successful!',
        })
    }

    /*
    * 根据权限生成按钮列表
    * */
    generateToolBtns = (item,scope,actor) => {
        const { toolBtns } = this.props;
        let btnList = toolBtns || [];
        if (scope === 'repo') {
            if (item.hidden) {
                if (actor === 2) {
                    btnList = ['download', 'update', 'active'];
                } else {
                    btnList = ['download'];
                }
            } else {
                if (actor === 2) {
                    btnList = ['download', 'cart', 'delete', 'update'];
                } else {
                    btnList = ['download', 'cart'];
                }
            }
        } else if (scope === 'project') {
            if (item.deleted) {
                if (item.scope === 'project') {
                    btnList = ['download'];
                } else {
                    btnList = ['download', 'cart'];
                }
            } else {
                if (actor === 2) {
                    if (item.scope === 'project') {
                        btnList = ['download', 'update', 'delete'];
                    } else {
                        btnList = ['download', 'cart', 'delete'];
                    }
                } else {
                    if (item.scope === 'project') {
                        btnList = ['download'];
                    } else {
                        btnList = ['download', 'cart'];
                    }
                }
            }
        } else if (scope === 'search') {
            if (item.status === 16) {
                btnList = ['download'];
            } else {
                btnList = ['download', 'cart'];
            }
        } else if (scope === 'cart') {
            btnList = ['delete'];
        }
        return btnList;
    }

    copyError = (value) => {
        this.setState({
            copytipShow: true,
            copyError: true,
        });
        let copyNode = document.getElementsByClassName('g-copy-input')[0];
        if (!copyNode) {
            copyNode = document.createElement('input');
            copyNode.className = 'g-copy-input';
            copyNode.style.cssText = 'width: 1px; height: 1px; opacity: 0;';
            document.body.appendChild(copyNode);
        }
        copyNode.value = value;
        copyNode.select();
    }

    copyEnd = () => {
        if (this.state.copytipShow) {
            this.setState({
                copytipShow: false,
            });
        }
    }

    isSelected = (iconId) => {
        const iconsInLocalStorage = getIconsInLs();
        return iconsInLocalStorage.has(iconId);
    }

    selectIcon = (iconId) => {
        // if (e.target === this.refs.code) return;
        const iconsInLocalStorage = getIconsInLs();
        if (iconsInLocalStorage.has(iconId)) {
            deleteIconInLs(iconId)
        } else {
            addIconsInLs([iconId]);
        }
        // this.updateContainedState()
    }

    preventSelect = (e) => {
        e.nativeEvent.stopPropagation();
    }

    defaultDownloadIcon = () => {
        const { onDownload, scope } = this.props;
        if(scope === 'cart'){
            return
        }
        try{
            if(onDownload && typeof onDownload === 'function'){
                onDownload();
            }
        }catch(e){
            console.log(e)
        }
    }

    render() {
        const { toolBtns, isShowCopyBtn, scope } = this.props;
        const {
            icon, onDownload, onUpdate, onDelete, onActive, toolStyle = {}
        } = this.props;
        const { showButtons, toolList } = this.state;
        const selected = this.isSelected(icon.materialId);
        const fill = selected ? '#008ed6' : '#555f6e';

        const copyBtn = (
            <ClipboardButton
                component="div"
                className="tool-item copy"
                button-title="复制编码"
                data-clipboard-text={`${icon.fontClass || icon.iconCode || ''}`}
                onSuccess={this.copySuccess}
                button-onMouseOut={this.copyEnd}
                key="copyCoding"
            >
                <i className="iconfont icon-test-copy" />
                复制代码
            </ClipboardButton>
        );

        return (
            <div className={
                `icon-detail-item
                ${scope}
                ${selected && scope !== 'cart' ? 'active' : ''}
                ${isShowCopyBtn ? 'hasCoptBtn' : ''}
                ${showButtons.length > 0 ? 'showBtns' : ''}
                `}
            >
                <div className="info">
                    <div className="icon">
                        <Icon
                            size={32}
                            fill={fill}
                            svgpath={icon.svgPath}
                            ref="icon"
                        />
                        {
                            this.props.icon.added ? (<div className="label added"><span>新上传</span></div>) : null
                        }
                        {
                            this.props.icon.deleted ? (<div className="label deleted"><span>已删除</span></div>) : null
                        }
                        {
                            this.props.icon.replaced ? (
                                <div className="label replaced"><span>已替换</span></div>) : null
                        }

                    </div>
                    <div
                        className="name text-ellipsis"
                        title={icon.materialName}
                    >
                        {icon.materialName}
                    </div>
                    <div className="font-class text-ellipsis">
                        {`${icon.fontClass || icon.iconCode || ''}`}
                    </div>
                </div>
                <div className={`tool`} style={{...toolStyle,cursor: scope === 'cart' ? 'default' : 'pointer'}} onClick={(e)=>{
                    if(e.target.closest('.tool-item')){
                        return
                    }
                    this.defaultDownloadIcon()
                }}>
                    {
                        showButtons.length > 0 &&
                            <div className='buttonsContainer'>
                                {showButtons}
                            </div>
                    }
                    {isShowCopyBtn ? copyBtn : null}
                </div>
                {/* {isShowCopyBtn ? copyTip : null} */}
            </div>
        );
    }
}

export default withRouter(IconItem);
